var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('plc',{attrs:{"columnNames":_vm.columnName},on:{"deviceData":_vm.deviceDatas}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }